var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styles.message)},[_c('p',{class:`${_vm.routeLink}_fortext`,style:(_vm.styles.messageTxt)},[_vm._v(_vm._s(_vm.messageText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }